// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"38e25796","352":"a8b28252","382":"85c86cca"}[chunkId] + ".chunk.css";
};